// タッチしたとき開始位置を保存しておく(iPhoneモーダル対策)
jQuery(function ($) {
  // ページ先頭に戻るボタン
  $(document).ready(function () {
    'use strict';

    var top_btn = $('.e_totop');
    top_btn.hide();
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        top_btn.fadeIn();
      } else {
        top_btn.fadeOut();
      }
    });
    top_btn.click(function () {
      $('body,html').animate({
        scrollTop: 0
      }, 400);
      return false;
    });
  });
  $(document).ready(function () {
    if (window.matchMedia('(max-width:940px)').matches) {
      var touch_start_y;
      $(window).on('touchstart', function (event) {
        touch_start_y = event.originalEvent.changedTouches[0].screenY;
      });

      if ($('div#cart_bottom').length) {
        $('body').append($('<div class="m_sp_fix_btn">').append('<span>カート<br>を見る</span>'));
      }

      $('.m_sp_fix_btn').click(function () {
        $('.m_product_fix').toggleClass("current");
        $('.body_fix').toggleClass("current");
        $('body').toggleClass('modal_open');
        $('.modal-overlay').toggle();
        if ($('body').hasClass('modal_open')) {
          $(window).on('touchmove.noscroll', function (event) {
            var current_y = event.originalEvent.changedTouches[0].screenY,
              height = $('.m_product_fix_cnts').outerHeight(),
              is_top = touch_start_y <= current_y && $('.m_product_fix_cnts')[0].scrollTop === 0,
              is_bottom = touch_start_y >= current_y && $('.m_product_fix_cnts')[0].scrollHeight - $('.m_product_fix_cnts')[0].scrollTop - height < 5;
            // スクロール対応モーダルの上端または下端のとき
            if (is_top || is_bottom || !$(event.target).closest('.m_product_fix_cnts').length > 0 || $(event.target).hasClass('.modal-overlay')) {
              // スクロール禁止
              event.preventDefault();
            }
          });
        } else {
          $(window).off('touchmove.noscroll');
        }
      });
      $('.m_news .modal-open').click(function () {
        $('body').addClass('modal_open');
        $('.modal-overlay').click(function () {
          $('body').removeClass('modal_open');
        });
        $('.modal-close').click(function () {
          $('body').removeClass('modal_open');
        });
      });
    } else {}
  });
  $(document).ready(function () {
    if (window.matchMedia('(max-width:940px)').matches) {
      $('.m_foot_link ul').wrap('<div class="m_sp_foot_list">');
      $('.m_foot_link .m_sp_foot_list').prepend('<p class="m_sp_foot_list_ttl"></p>');
      $('.m_foot_link .m_sp_foot_list .m_sp_foot_list_ttl').click(function () {
        //						$(this).toggleClass("current");
        //						$(this).next().slideToggle();
      });
    } else {}
  });


  // 画像切り替え
  $(document).ready(function () {
    var $setElem = $('.switch'),
      pcName = '_pc', // PC版のファイル名
      spName = '_sp', // スマホ版のファイル名
      replaceWidth = 768; // 切り替える画面サイズ

    $setElem.each(function () {
      var $this = $(this);

      function imgSize() {
        var windowWidth = parseInt($(window).width());
        if (windowWidth >= replaceWidth) {
          $this.attr('src', $this.attr('src').replace(spName, pcName)).css({
            visibility: 'visible'
          });
        } else if (windowWidth < replaceWidth) {
          $this.attr('src', $this.attr('src').replace(pcName, spName)).css({
            visibility: 'visible'
          });
        }
      }
      $(window).resize(function () {
        imgSize();
      });
      imgSize();
    });
  });

  $(document).ready(function () {
    $('.m_head_nav_btn').click(function () {
      $(this).toggleClass("current");
      $(this).next().slideToggle();
    });
  });

  $(document).ready(function () {
    if (window.matchMedia('(max-width:940px)').matches) {
      $('.m_product_fix_cash .e_product_cash_btn').click(function () {
        $('.m_product_fix').removeClass("current");
        $('.body_fix').removeClass("current");
        $('body').removeClass('modal_open');
        $('.modal-overlay').hide();
        $(window).off('touchmove.noscroll');
      });
      $('.modal-overlay').click(function () {
        $('.m_product_fix').removeClass("current");
        $('.body_fix').removeClass("current");
        $('body').removeClass('modal_open');
        $('.modal-overlay').hide();
        $(window).off('touchmove.noscroll');
      });
    } else {
      $('.m_product_fix_cash .e_product_cash_btn').click(function () {
        $(this).toggleClass("current");
        $('.m_product_fix_cnts').slideToggle();
      });
    }
  });

  $(document).ready(function () {
    if (window.matchMedia('(max-width:750px)').matches) {
      $('.e_head_mypage .e_li .e_mypage').click(function () {
        $(this).children("div").slideToggle().toggleClass('e_li_parent_hover');
      });
    } else {
      $('.e_head_mypage .e_li .e_mypage').hover(function () {
        $(this).children("div").stop(true, false).slideToggle(300).parent().toggleClass('e_li_parent_hover');
      });
    }
  });


  $(document).ready(function () {
    $('.m_news_blk:first  h2').addClass("current");
    $('.m_news_blk:not(:first) .m_news_item').hide();
    $('.m_news_blk h2').click(function () {
      $(this).toggleClass("current");
      $(this).next().slideToggle();
    });
  });

  $(document).ready(function () {
    $('.e_menu li').click(function () {
      var index = $('.e_menu li').index(this);

      $('.m_content .m_content_item').css('display', 'none');
      $('.m_content .m_content_item').eq(index).css('display', 'block');
      $('.e_menu li').removeClass('select');
      $(this).addClass('select');
    });
  });
});


// アコーディオンの挙動調整
$(window).resize(function () {
  // windowの幅をxに代入
  var x = $(window).width();
  // windowの分岐幅をyに代入
  var y = 940;
  if (x >= y) {
    $('.m_head_nav').css('display', '');
    $('.m_product_sec dd').css('display', '');
    $('body').removeClass('modal_open');
  } else {}
});


// facebook
$(function () {
  var windowWidth = $(window).width();
  var htmlStr = $('.m_sns').html();
  var timer = null;
  $(window).on('resize', function () {
    var resizedWidth = $(window).width();
    if (windowWidth != resizedWidth && resizedWidth < 500) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        $('.m_sns').html(htmlStr);
        window.FB.XFBML.parse();
        // window.FB.XFBML.parse()で再レンダリングします。
        var windowWidth = $(window).width();
      }, 500);
    }
  });
});

// サイドナビ虫眼鏡ボタン
$(function () {
  if (window.matchMedia('(max-width:768px)').matches) {
    $('#search_text').css('width', '116px');
  }
  $('#search_button').click(function (e) {
    search_form.submit();
  });
});


// 電話制御
$(function () {
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);

  if (!isMobile) {
    $('a[href^="tel:"]').on('click', function (e) {
      e.preventDefault();
    });
  }
});

// タブ
$(window).on('load resize', function () {
  $('.tabBox').hide(); // 最初の「中身」だけ表示しておく
  $('.tabBox:first').show(); // 最初の「中身」だけ表示しておく
  $('.tab li:first').addClass('active'); // 最初のタブにクラスがつく
  $('.tab li').off('click');
  $('.tab li').click(function () {
    $('.tab li').removeClass('active'); // タブをクリックするとタブからクラスが取れる
    $(this).addClass('active'); // 今のタブにクラスがつく
    $('.tabBox').hide(); // 「中身」が非表示になる

    $($(this).find('a').attr('href')).fadeIn(); // クリックしたアンカーのhrefにセットされた「中身」を読み込む
    return false;
  });
});


// 商品ページ メニュー（アコーディオン）部分
$(function () {
  $('.js-menu__item__link').each(function () {
    $(this).on('click', function () {
      $(this).toggleClass('on');
      $("+.submenu", this).slideToggle()
      return false;
    });
  });
});


// お問い合わせ
$(function () {
  $(".e_contact .e_link,.ft_contact .e_link").on("click", function () {
    $(this).next().slideToggle();
    $(this).toggleClass('on');
  });
});